import { render } from "./ExportsPage.vue?vue&type=template&id=07ab9c24"
import script from "./ExportsPage.vue?vue&type=script&lang=js"
export * from "./ExportsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__